// helpPath.ts — the address of the Help page, on its own.
//
// Separate from HelpPage so the nav registry can name the path without
// importing the page, which reads the registry back.

/** `/help`: how to get around this app. */
export const HELP_PATH = '/help';
